exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.listeAllChatsAgent {height: 100% !important;\n}\n.listeChatsAgents {cursor: pointer;\n}\n.ContentListChats {height: calc(100% - 48px) !important;  overflow-y: auto;\n}\n.ContentListeAgents ul li div {margin-left: 0px !important;\n}\n.offline {background-color: #ef4f4f;\n}\n.online {background-color: #1cde7b;\n}\n.statusVisiteur { \n  height: calc(100% - 8px);\n  width: 2px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  margin-right: 4px;\n}\n.v-list {padding: 0px 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzListChatsAgent.vue
// module id = ER4t
// module chunks = 1